import { DateTime } from "luxon";

const TIME_ZONES = {
  ja: "Asia/Tokyo",
  "zh-TW": "Asia/Taipei",
  en: "Europe/Warsaw",
  th: "Asia/Bangkok",
};

export const memoryRollbackTimeZone = (lng) => TIME_ZONES[lng] || "Asia/Tokyo";

export const formatMemoryRollbackTime = (value, lng) => {
  const dt = DateTime.fromISO(value, { zone: "utc" })
    .setZone(memoryRollbackTimeZone(lng))
    .setLocale(lng);
  return dt.toFormat(lng === "en" ? "MMM d, yyyy HH:mm" : "yyyy/MM/dd HH:mm");
};
